import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { selectDialogState } from '../../../../dialog/features/dialog.selectors';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogService } from '../../../../dialog/services/dialog.service';
import { filter } from 'rxjs/operators';
import { selectUser } from '../../../features/data/data.selectors';
import { ContactUs } from '../../../features/data/data.actions';
import * as _ from 'lodash';
import { WhitespaceValidator } from '../../../validators/whitespace.validator';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  public user$ = this.store.pipe(
    select(selectUser)
  );

  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));

  public form: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required, WhitespaceValidator()]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    subject: new UntypedFormControl('', [Validators.required, WhitespaceValidator()]),
    message: new UntypedFormControl('', [Validators.required, WhitespaceValidator()])
  });


  loggedIn: any = false;

  constructor(
    private store: Store,
    private dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.user$.pipe(
      filter(user => !_.isNull(user)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(user => {
        this.loggedIn = true;
        this.form.addControl('orgId', new UntypedFormControl(''));
        this.form.get('name').setValue(user.name);
        this.form.get('email').setValue(user.email);
        this.form.get('orgId').setValue(user.id);
    });
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
  }

  confirm(dialog, value) {
    const { form } = this;

    this.cleanForm(form);

    if (form.invalid) {
      return form.markAllAsTouched();
    }

    this.store.dispatch({
      type: ContactUs.type,
      payload: form.value
    });

    this.close(dialog, value);
  }

  getErrorMessage(prop) {
    const { form } = this;
    const name = form.get(prop);
    const fields = {
      name: 'Name',
      subject: 'Subject',
      message: 'Message'
    };

    if (!name.touched) {
      return '';
    }

    if (name.hasError('required')) {
      return `Please provide ${prop}`;
    }

    if (name.hasError('empty')) {
      return `${fields[prop]} can\'t contain only spaces `;
    }

    return '';
  }

  close(dialog, value) {
    this.dialogService.closeDialogSubject.next(value);

    const { initialState: { action, callback } } = dialog;
    if (value) {
      if (action) {
        this.store.dispatch(action);
      }
      callback(value);
    }
  }

   cleanForm(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const field = formGroup.get(key);

      if (!_.isNull(field.value)) {
        field.setValue(field.value.trim());
      }
    });
  }
}
